import { render, staticRenderFns } from "./AdminInventorySubMenusLinks.vue?vue&type=template&id=0da9cd5d"
import script from "./AdminInventorySubMenusLinks.vue?vue&type=script&lang=js"
export * from "./AdminInventorySubMenusLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da9cd5d')) {
      api.createRecord('0da9cd5d', component.options)
    } else {
      api.reload('0da9cd5d', component.options)
    }
    module.hot.accept("./AdminInventorySubMenusLinks.vue?vue&type=template&id=0da9cd5d", function () {
      api.rerender('0da9cd5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/sub-menus/inventory/AdminInventorySubMenusLinks.vue"
export default component.exports